module.exports = __webpack_public_path__ + "img/foryou.b7534603.png";